export default [
    { id: 26, name: 'Agem' },
    // { id: 27, name: 'Anode Energie' },
    { id: 66, name: 'ANWB Energie' },
    { id: 79, name: 'Atlas Power and Gas' },
    { id: 24, name: 'Betuwe stroom' },
    { id: 2, name: 'Budget Energie' },
    { id: 58, name: 'CEN / WoonEnergie' },
    { id: 54, name: 'Clean Energy' },
    { id: 68, name: 'Coolblue Energie' },
    { id: 28, name: 'De Groene Stroomfabriek' },
    { id: 59, name: 'De Vrije Energie Producent' },
    { id: 25, name: 'Delta Energie' },
    { id: 51, name: 'Discount Energie' },
    { id: 46, name: 'Dorpstroom' },
    { id: 53, name: 'DVEP Energie' },
    { id: 3, name: 'E.on' },
    { id: 45, name: 'Easyenergy' },
    { id: 4, name: 'Eneco' },
    { id: 19, name: 'Energie VanOns' },
    { id: 42, name: 'Energiebesteding' },
    { id: 5, name: 'Energiedirect' },
    { id: 21, name: 'Energieflex' },
    { id: 37, name: 'Energyhouse' },
    { id: 49, name: 'EnergyZero' },
    { id: 52, name: 'EnerZie' },
    { id: 6, name: 'Engie' },
    { id: 7, name: 'Essent' },
    // { id: 35, name: 'Fenor energie' },
    { id: 71, name: 'Frank energie' },
    { id: 72, name: 'Gewoon Energie' },
    { id: 56, name: 'Gezinsenergie' },
    { id: 8, name: 'Greenchoice' },
    { id: 43, name: 'GreenNL' },
    { id: 40, name: 'Groenpand' },
    { id: 81, name: 'GroenStroomLokaal' },
    { id: 78, name: 'Gulf Gas and Power' },
    { id: 44, name: 'Hezelaer' },
    { id: 69, name: 'HollandsStroom' },
    { id: 9, name: 'Holland Wind' },
    { id: 20, name: 'Huismerk Energie' },
    { id: 30, name: 'HVC Kringloop Energie' },
    { id: 50, name: 'Kikker Energie/DGB Energie' },
    { id: 23, name: 'Innova Energie' },
    { id: 77, name: 'Live Energy' },
    { id: 10, name: 'Main energie' },
    { id: 76, name: 'Mega Energie' },
    { id: 65, name: 'Mijn Domein Energie' },
    { id: 74, name: 'NextEnergy' },
    { id: 61, name: 'Nieuw Hollands Energiebedrijf' },
    { id: 38, name: 'NieuweStroom' },
    { id: 80, name: 'Noordstroom' },
    { id: 1, name: 'OM' },
    { id: 18, name: 'Overig' },
    { id: 14, name: 'Oxxio' },
    { id: 39, name: 'ParkStroom' },
    { id: 62, name: 'PostcodeStroom' },
    { id: 36, name: 'Power peers' },
    { id: 75, name: 'Prikenergie' },
    { id: 15, name: 'Pure energie' },
    { id: 63, name: 'PZEM' },
    // { id: 16, name: 'Qurrent' },
    { id: 48, name: 'Qwint' },
    { id: 55, name: 'Samsam' },
    { id: 60, name: 'Sefe energie' },
    { id: 31, name: 'Sepa Green' },
    { id: 32, name: 'Servicehouse' },
    { id: 67, name: 'Shell Energie' },
    { id: 70, name: 'Tibber' },
    { id: 34, name: 'Total' },
    { id: 22, name: 'United Consumers' },
    { id: 17, name: 'VanDeBron' },
    { id: 13, name: 'Vattenfall' },
    { id: 64, name: 'Vrij Op Naam' },
    { id: 47, name: 'Welkom Energie' },
    { id: 41, name: 'Windcentrale' },
    { id: 73, name: 'Zonneplan' },
    { id: 57, name: 'Onbekend/n.v.t.' },
];
